module.exports = __webpack_public_path__ + "img/deep-dive-report-old.459375a8.png";